import { LoadersType } from '../types';

const initialState: LoadersType = {
    externalLoaders: [],
    internalLoaders: []
};

export default initialState;
